import React from "react";
import PropTypes from "prop-types";
import styled, { keyframes } from "styled-components";
import { useTranslation } from "react-i18next";

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
`;

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 7px;
  border-radius: 999px;
  background: ${({ theme }) => theme.color.error.main};
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.2;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
  animation: ${pulse} 2.2s ease-in-out infinite;
  pointer-events: none;
  white-space: nowrap;
`;

const Floating = styled(Badge)`
  position: absolute;
  top: ${({ $top }) => $top};
  right: ${({ $right }) => $right};
  z-index: 2;
`;

/**
 * Selo "novo" para chamar atenção em features em prototipagem (demo).
 * Use `floating` dentro de um container `position: relative`.
 */
const NewFeatureBadge = ({ floating, top, right, label }) => {
  const { t } = useTranslation();
  const badgeLabel = label || t("common.messages.badgeNew");

  if (floating) {
    return (
      <Floating $top={top} $right={right} aria-label={badgeLabel}>
        {badgeLabel}
      </Floating>
    );
  }
  return <Badge aria-label={badgeLabel}>{badgeLabel}</Badge>;
};

NewFeatureBadge.propTypes = {
  floating: PropTypes.bool,
  top: PropTypes.string,
  right: PropTypes.string,
  label: PropTypes.string
};

NewFeatureBadge.defaultProps = {
  floating: false,
  top: "0",
  right: "0",
  label: undefined
};

export default NewFeatureBadge;
